const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/middleware/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        '401': 'Die Sitzung ist abgelaufen. Bitte loggen Sie sich erneut ein.',
    },
    __RELATIVE_SOURCE_FILE__
);
